import { __rest } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { styleClasses } from "../../helpers";
import { Modal as AntdModal } from "antd";
import "./Modal.scss";
import { Icon } from "../../particles/Icon";
const CSS_PREFIX = `lav-components-modal`;
export const Modal = (props) => {
    const { className = "", footer = null, size = "small", title, type = "default", variant = "basic" } = props, modalProps = __rest(props, ["className", "footer", "size", "title", "type", "variant"]);
    return (_jsx(AntdModal, Object.assign({ className: classNames(styleClasses(CSS_PREFIX, { variant, size }), {
            [className]: !!className,
        }), closeIcon: _jsx(Icon, { variant: "IconX", size: "extra-small", color: "dark" }), footer: footer, title: variant === "image" ? (_jsx(ImageTitle, Object.assign({}, props))) : (_jsx(IconTitle, Object.assign({}, props))) }, modalProps)));
};
const ImageTitle = ({ image, title }) => {
    return (_jsxs(_Fragment, { children: [_jsx("img", { src: image, className: `${CSS_PREFIX}-image` }), title] }));
};
// Add illustration with correct spacing to title if variant is basic and type is illustration
const IconTitle = ({ illustration, title, type, variant }) => {
    let iconProps = undefined;
    switch (variant) {
        case "basic":
            if (type === "illustration") {
                iconProps = illustration;
            }
            break;
        case "alert":
            switch (type) {
                case "info":
                    iconProps = {
                        variant: "IconInfoSquareRoundedFilled",
                        size: "large",
                        style: { color: "var(--color-lavender-400)" },
                    };
                    break;
                case "danger":
                    iconProps = {
                        variant: "IconCircleXFilled",
                        size: "large",
                        color: "negative",
                    };
                    break;
                case "warning":
                    iconProps = {
                        variant: "IconAlertTriangleFilled",
                        size: "large",
                        color: "warning",
                    };
                    break;
                case "success":
                    iconProps = {
                        variant: "IconCircleCheckFilled",
                        size: "large",
                        color: "positive",
                    };
                    break;
            }
            break;
    }
    return iconProps ? (_jsxs(_Fragment, { children: [_jsx(Icon, Object.assign({}, iconProps)), title] })) : (title);
};
